import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import variables from '../../theme/variables.scss'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Box from '@mui/material/Box'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

import { toggleMedicalHistoryModal } from '../../redux/modals/toggleModal.actions'
import {
    getMedicalHistoryListData,
    getPastMedicalHistoryListData,
    setCurrentMedicalHistory,
} from '../../redux/medicalHistory/medicalHistory.action'

import MedicalDetails from './medical-details/index'
const AntTabs = styled(Tabs)({
    marginTop: '-0.625rem',

    borderBottom: 'none',
    '& .MuiTabs-indicator': {
        backgroundColor: variables.purple,
    },
})

const AntTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
    textTransform: 'none',
    minWidth: 0,
    // lineHeight: 1,
    [theme.breakpoints.up('sm')]: {
        minWidth: 0,
    },
    fontWeight: 500,
    marginRight: theme.spacing(2),
    padding: 0,
    color: variables.gray600,
    fontFamily: 'Inter',
    '&:hover': {
        color: variables.purple,
        opacity: 1,
    },
    '&.Mui-selected': {
        color: variables.purple,
        fontWeight: 600,
    },
    '&.Mui-focusVisible': {
        backgroundColor: variables.blue100,
    },
}))

export const Index = ({ patientId, token, currentMedicalHistory, isDemoPatient }) => {
    const dispatch = useDispatch()
    const [value, setValue] = React.useState(currentMedicalHistory ?? 'other')
    const [expanded, setExpanded] = React.useState(true)

    useEffect(() => {
        setValue(currentMedicalHistory)
    }, [currentMedicalHistory])

    const handleChange = (event, newValue) => {
        setValue(newValue)
        getInitialValue(newValue)
    }

    const getInitialValue = (val) => {
        switch (val) {
            case 'other':
                const payloadMedicalHistoryList = {
                    patientId: patientId,
                    type: 'other',
                    status: 'active',
                }
                dispatch(getMedicalHistoryListData(payloadMedicalHistoryList, token))
                dispatch(setCurrentMedicalHistory('other'))
                break
            case 'past':
                const payloadPastMedicalHistoryList = {
                    patientId: patientId,
                    type: 'other',
                    status: 'past',
                }
                dispatch(getPastMedicalHistoryListData(payloadPastMedicalHistoryList, token))
                dispatch(setCurrentMedicalHistory('past'))
                break

            default:
                return null
        }
    }

    const OpenModal = (val) => {
        switch (val) {
            case 'other':
                const payload0 = {
                    patientId: patientId,
                    type: 'other',
                    status: 'active',
                }
                dispatch(getMedicalHistoryListData(payload0, token))
                dispatch(toggleMedicalHistoryModal(true))
                dispatch(setCurrentMedicalHistory('other'))

                break
            case 'past':
                const payloadPast = {
                    patientId: patientId,
                    type: 'other',
                    status: 'past',
                }
                dispatch(getPastMedicalHistoryListData(payloadPast, token))
                dispatch(toggleMedicalHistoryModal(true))
                dispatch(setCurrentMedicalHistory('past'))
                break

            default:
                dispatch(toggleMedicalHistoryModal(true))
        }
    }

    return (
        <div>
            <Accordion className="dashboard-accordion" sx={{ boxShadow: 'none' }} expanded={expanded}>
                <AccordionSummary
                    sx={{
                        background: variables.gray100,
                        boxShadow: 'none',
                        borderRadius: '0.25rem',
                        borderBottomLeftRadius: !!expanded ? '0rem' : '0.25rem',
                        borderBottomRightRadius: !!expanded ? '0rem' : '0.25rem',
                        padding: '0px 2px 0px !important',
                        cursor: 'unset !important',
                    }}
                    expandIcon={
                        <ExpandMoreIcon
                            style={{ cursor: 'pointer' }}
                            onClick={() => setExpanded(!expanded)}
                        />
                    }
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                >
                    <Typography
                        className="gray-900 cursor-default fs-8 fw-normal"
                        sx={{
                            width: '100%',
                            color: 'text.secondary',
                            fontSize: '0.85rem',
                            background: variables.gray100,
                            boxShadow: 'none',
                            padding: '4px 2px 0px  !important',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            fontWeight: 600,
                        }}
                    >
                        Medical History
                        <span className="ms-2 me-1 cursor-pointer">
                            <img
                                onClick={(event) => {
                                    OpenModal(value)
                                    event.stopPropagation()
                                }}
                                src="/images/right-top-arrow.svg"
                                alt="go to icon"
                            />
                        </span>
                    </Typography>
                </AccordionSummary>
                <AccordionDetails
                    sx={{
                        padding: '0px 0px 4px !important',
                    }}
                >
                    <Typography
                        className="gray-600 cursor-default"
                        sx={{
                            background: variables.gray100,
                            boxShadow: 'none',
                            borderBottomLeftRadius: '0.25rem',
                            borderBottomRightRadius: '0.25rem',
                            padding: '0px 2px 0px !important',
                        }}
                    >
                        <AntTabs value={value} onChange={handleChange} aria-label="ant example">
                            <AntTab label="Active" value="other" />
                            <AntTab label="Past" value="past" disabled={!!isDemoPatient} />
                        </AntTabs>
                    </Typography>

                    <Box sx={{ paddingTop: 1, paddingBottom: 1 }}>
                        {value === 'other' && (
                            <>
                                <MedicalDetails detail="other" />
                            </>
                        )}
                        {value === 'past' && (
                            <>
                                <MedicalDetails detail="past" />
                            </>
                        )}
                    </Box>
                </AccordionDetails>
            </Accordion>
        </div>
    )
}

const mapStateToProps = (state) => ({
    patientId: state.patient.patientData.patientId,
    token: state.loginData.loginResponse.accessToken,
    currentMedicalHistory: state?.medicalHistory?.currentMedicalHistory,
    isDemoPatient: state.patient.patientData.isDemoPatient,
})

const mapDispatchToProps = (dispatch) => {
    return {
        toggleMedicalHistoryModal: (payload) => dispatch(toggleMedicalHistoryModal(payload)),
        getMedicalHistoryListData: (payload, token) => dispatch(getMedicalHistoryListData(payload, token)),
        getPastMedicalHistoryListData: (payload, token) =>
            dispatch(getPastMedicalHistoryListData(payload, token)),
        setCurrentMedicalHistory: (payload) => dispatch(setCurrentMedicalHistory(payload)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Index)
